module.exports = __webpack_public_path__ + "img/phone_header.854e2209.svg";